import i18next from 'i18next';
import Backend from 'i18next-xhr-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

i18next
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: false,
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    ns: 'common',
    defaultNS: 'common',
    detection: {
      order: ['cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag', 'path', 'subdomain', 'querystring'],
      lookupCookie: 'locale',
      lookupLocalStorage: 'locale',
      caches: ['cookie', 'localStorage'],
      cookieMinutes: 60 * 24 * 30,
      htmlTag: document.documentElement,
    },
  });

export default i18next;
